module.exports = __webpack_public_path__ + "img/device_cyberblade.2f9837cd.png";